export default "__VITE_ASSET__DWiY6z0e__"